import { StyleSheet } from 'react-native';
import theme from '@/constants/colors';

export default StyleSheet.create({
  container: { flex: 1, backgroundColor: theme.backgroundPrimary },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 10,
    gap: 12,
  },
  backButton: { padding: 4 },
  title: { flex: 1, fontSize: 17, fontWeight: '600', color: theme.textPrimary },
  loading: { flex: 1, alignItems: 'center', justifyContent: 'center' },
  errorText: { color: theme.textMuted, fontSize: 14, textAlign: 'center', marginBottom: 10 },
  retryButton: { paddingHorizontal: 14, paddingVertical: 8, borderRadius: 10, backgroundColor: theme.backgroundSecondary },
  retryText: { color: theme.accentPrimary, fontSize: 14, fontWeight: '600' },
  listContent: { paddingVertical: 8 },
  composerRow: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: 8,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: theme.borderSubtle,
  },
  attachButton: { padding: 8 },
  input: {
    flex: 1,
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 18,
    paddingHorizontal: 14,
    paddingVertical: 8,
    color: theme.textPrimary,
    fontSize: 15,
    maxHeight: 100,
    borderWidth: 1,
    borderColor: theme.borderSubtle,
  },
  sendButton: { padding: 8 },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.6)',
  },
  // poll keyboard layout: spacer replaces 'center' (a centered KAV fights the
  // keyboard shift) — the card anchors to the bottom above the keyboard
  modalOverlaySpacer: { flex: 1 },
  pollScroll: { maxHeight: '75%', width: '100%' },
  wideCard: { width: '92%', padding: 16, marginHorizontal: 8 },
  pinScroll: { maxHeight: '72%', width: '100%' },
  pinMap: { height: 260, width: '100%', borderRadius: 12, marginVertical: 10 },
  pollScrollContent: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingBottom: 24,
  },
  pinScrollContent: { width: '100%', paddingBottom: 8 },
  modalCard: {
    width: '86%',
    backgroundColor: theme.backgroundSecondary,
    borderRadius: 16,
    padding: 16,
  },
  modalTitle: { fontSize: 16, fontWeight: '600', color: theme.textPrimary, marginBottom: 10 },
  modalEmpty: { color: theme.textMuted, fontSize: 14, marginVertical: 8 },
  trailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 10,
  },
  trailRowText: { color: theme.textPrimary, fontSize: 14, flex: 1 },
  modalClose: { alignSelf: 'flex-end', paddingVertical: 6 },
  modalCloseText: { color: theme.textMuted, fontSize: 13 },
  pollQuestionInput: {
    marginLeft: 0,
    marginBottom: 8,
    width: '100%',
    flex: 0,
    minHeight: 42,
    backgroundColor: theme.backgroundPrimary,
    borderColor: theme.borderSubtle,
  },
  pollOptionRow: { flexDirection: 'row', alignItems: 'center', gap: 6, marginBottom: 6 },
  pollOptionInput: { marginBottom: 0, backgroundColor: theme.backgroundPrimary, borderColor: theme.borderSubtle },
  pollRemove: { color: theme.textMuted, padding: 6 },
  pollAdd: { alignSelf: 'flex-start', paddingVertical: 6 },
  pollAddText: { color: theme.accentPrimary, fontSize: 13 },
  pollMeta: { color: theme.textMuted, fontSize: 12 },
  sendButtonFull: {
    marginTop: 10,
    backgroundColor: theme.accentPrimary,
    borderRadius: 12,
    paddingVertical: 10,
    alignItems: 'center',
  },
  sendButtonFullText: { color: theme.backgroundPrimary, fontWeight: '600' },
});
